// The message of an API error: Administración answers 409/422 with `detail`
// as a string, as { code, message }, or (FastAPI validation) as a list.
export function detalleError(e, fallback) {
  const d = e?.response?.data?.detail
  if (typeof d === 'string') return d
  if (d?.message) return d.message
  if (Array.isArray(d) && d.length) return d.map(x => x.msg).filter(Boolean).join(' · ') || fallback
  return fallback
}
